<template>
  <div style="padding: 16px 24px" class="choose-response-tree">
    <el-tree :data="stageData" :render-content="renderContent"></el-tree>
  </div>
</template>

<script>
import { componentNames } from "dependencies/base"
export default {
  props: {
    responseRectIds: Object,
    innerElementLabel: String
  },
  data() {
    return {
      stageData: [],
      hoverEl: null
    }
  },
  methods: {
    renderContent(h, { node, data, store }) {
      return (
        <span onMouseover={() => this.mouseoverItem(data)}>
          <span class="mr8">{data.label}</span>
          {data.ids ? <el-radio value={false} onChange={() => this.chooseRect(data)} /> : ""}
        </span>
      )
    },
    clearHoverEl() {
      if (this.hoverEl) this.hoverEl.classList.remove("hover-item")
    },
    mouseoverItem(data) {
      const ids = { ...data.ids }
      delete ids.pageId
      const idsStr = this.$event.getIdsByStrId(ids)
      this.clearHoverEl()
      this.hoverEl = document.getElementsByClassName(idsStr)[0]
      if (this?.hoverEl?.classList && !this.hoverEl.classList.contains("hover-item")) {
        this.hoverEl.classList.add("hover-item")
      }
    },
    chooseRect(data) {
      this.clearHoverEl()
      this.$emit("update:innerElementLabel", data.label)
      this.$emit("update:responseRectIds", { ...data.ids })
    },
    formateLayoutComponent(data, rectIds, res = []) {
      data.forEach(item => {
        if (item.height) {
          const rowData = { label: "行" }
          if (item?.cols?.length) {
            rowData.children = item.cols ? this.formateLayoutComponent(item.cols, rectIds) : []
            res.push(rowData)
          }
        } else if (item.width) {
          const colData = { label: "列" }
          if (item?.rows?.length) {
            colData.children = item.rows ? this.formateLayoutComponent(item.rows, rectIds) : []
            res.push(colData)
          } else if (item.elementOptions.length) {
            item.elementOptions.forEach(elementInLayout => {
              const elementInLayoutIds = {
                ...rectIds,
                uid: item.uid,
                elementInLayoutId: elementInLayout.elementInLayoutId
              }
              res.push({ label: componentNames[elementInLayout.innerElement], ids: elementInLayoutIds })
            })
          }
        }
      })
      return res
    },
    formateSwiperComponent(swiperPages, rectIds) {
      return swiperPages.map((page, index) => {
        return page.elementOptions.length
          ? {
              label: "轮播页" + index,
              children: page.elementOptions.map(elementInSwiper => {
                return {
                  label: componentNames[elementInSwiper.innerElement],
                  ids: {
                    ...rectIds,
                    elementInSwiperId: elementInSwiper.elementInSwiperId,
                    swiperContent_id: page.swiperContent_id
                  }
                }
              })
            }
          : { label: "轮播页" + index }
      })
    },
    initStageData() {
      const res = []
      const stage = this.$store.state[this.request_prefix]
      for (let i = 0; i < stage.page.children.length; i++) {
        const container = stage.page.children[i]
        const containerId = container.container_id
        const containerIds = { container_id: containerId }
        const containerData = { label: "画布", name: "container", ids: containerIds }
        if (container.children.length) {
          containerData.children = []
          for (let j = 0; j < container.children.length; j++) {
            const rect = container.children[j]
            const rectIds = { rect_id: rect.rect_id, ...containerIds }
            if (rect.shape === "swiperComponent") {
              componentNames[rect.shape] = "轮播"
            }
            const rectData = {
              label: componentNames[rect.shape],
              ids: rectIds
            }
            if (rect.shape.toLowerCase().includes("layout")) {
              //处理自由布局组件内的组件格式化为属性组件数据格式
              rectData.children = rect.options.rows ? this.formateLayoutComponent(rect.options.rows, rectIds) : []
            } else if (rect.shape.toLowerCase().includes("swiper")) {
              //处理轮播2组件内的组件格式化为属性组件数据格式
              rectData.children = rect.options.content ? this.formateSwiperComponent(rect.options.content, rectIds) : []
            }
            containerData.children.push(rectData)
          }
        }
        res.push(containerData)
      }
      //
      this.stageData = res
    }
  },
  mounted() {
    this.initStageData()
  },
  beforeDestroy() {
    this.clearHoverEl()
  }
}
</script>

<style>
.hover-item {
  opacity: 1;
}
.hover-item::after {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  opacity: 0.5;
  background: rgba(16, 245, 119, 1);
}
.choose-response-tree .el-tree-node > .el-tree-node__children {
  overflow-x: auto;
}
</style>
<style scoped>
::v-deep .el-tree-node__content:hover {
  background-color: var(--elTreeHoverColor) !important;
  color: var(--elCollapseItemContentColor);
}
::v-deep .is-current > .el-tree-node__content {
  /* background-color: var(--elTreeActiveColor) !important; */
  background-color: rgba(23, 112, 255, 0.5) !important;
  /* background: var(--elCollapseItemWrapBgColor) !important */
}
::v-deep .el-tree-node__content {
  background: var(--elCollapseItemWrapBgColor) !important;
}
::v-deep .el-tree {
  background: var(--elCollapseItemWrapBgColor) !important;
  color: var(--elCollapseItemContentColor);
}
</style>
